import moment from 'moment';

import DTO from './DTO';
import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';
import CarDTO from './CarDTO';
import { required } from '../utils/validation';

class VehiclesDTO extends DTO {
  constructor(params, isValidInit) {
    const ipAttr = new IndividualEntrepreneurDTO().getAttributes();
    const legalAttr = new JuridicalDTO().getAttributes();
    const carAttr = new CarDTO().getAttributes();
    const attributes = [
      {
        name: 'view_mode',
        type: String,
        validators: {},
        labelKey: 'view_mode',
      },
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'legal_entity_type',
        type: Number,
        validators: [],
        labelKey: 'legal_entity_type',
      },
      ...ipAttr,
      ...legalAttr,
      ...carAttr,
      {
        name: 'number',
        type: String,
        validators: [],
        labelKey: 'registry.number',
      },
      {
        name: 'effective_date',
        type: moment,
        validators: [required],
        labelKey: 'effective_date',
      },
      {
        name: 'expiration_date',
        type: moment,
        validators: [],
        labelKey: 'expiration_date',
      },
      {
        name: 'status',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },

      {
        name: 'insurer',
        type: String,
        validators: [],
        labelKey: 'insurer',
      },
      {
        name: 'insurance_contract_number',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_number',
      },
      {
        name: 'insurance_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_effective_date',
      },
      {
        name: 'insurance_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_expiration_date',
      },
      {
        name: 'decision',
        type: String,
        validators: [required],
        labelKey: 'decision',
      },
      {
        name: 'decision_date',
        type: String,
        validators: [required],
        labelKey: 'decision_date',
      },
      {
        name: 'vehicle_external_id',
        type: String,
        validators: [],
        labelKey: 'vehicle.external_id',
      },
      {
        name: 'vehicle_brand',
        type: String,
        validators: [],
        labelKey: 'vehicle_brand',
      },
      {
        name: 'vehicle_model',
        type: String,
        validators: [],
        labelKey: 'vehicle_model',
      },
      {
        name: 'vehicle_registry_number',
        type: String,
        validators: [],
        labelKey: 'Номер записи в реестре ЛТ',
      },
      {
        name: 'vehicle_lpn',
        type: String,
        validators: [],
        labelKey: 'vehicle_lpn',
      },
      {
        name: 'vehicle_vin',
        type: String,
        validators: [],
        labelKey: 'vehicle_vin',
      },
      {
        name: 'carrier_external_id',
        type: String,
        validators: [],
        labelKey: 'carrier.external_id',
      },
      {
        name: 'vehicle_color',
        type: String,
        validators: [],
        labelKey: 'vehicle_color',
      },
      {
        name: 'vehicle_status',
        type: String,
        validators: [],
        labelKey: 'Статус ТС',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default VehiclesDTO;
